export default __webpack_public_path__ + "static/media/Video.6f5acc81.svg";